<template>
	<el-main class="case">
		<ContentNav :bannerTextIMG="require('../../assets/case/bannerText.png')" :bannerimgIMG="Url.imgUrl + this.$store.state.NavList[4].banner"></ContentNav>
		<div class="content">
			<div class="container">
				<Menu :Menulist="{MenuList}" @changeNavIndex="loadCaseType"></Menu>
				<div class="contaniner-content">
					<div class="select">
						<div class="TimeOrder">
							<div>时间排序</div>
							<i v-for="(x,i) in OrderIcons" :key="i" :class="x.ClassName" @click="OrderArticles(i,x.val)" :style="OrderIconVal==i?'color:#D0A971':''"></i>
						</div>
						<div class="InputBox">
							<el-input placeholder="请输入文章关键字" v-model="ArtickeyWord">
								<el-button @click="GetkeyWordArtice" slot="append" icon="el-icon-search"></el-button>
							</el-input>
						</div>
					</div>
					<div class="itemList">
						<div class="itemList-box" v-for="(x,i) in CaseList.list" :key="i" @click="getDeatail(x)">
							<div class="title">{{x.title}}</div>
							<div class="text">{{x.describe}}</div>
						</div>
						<div class="Pages">
							<el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :total="CaseList.tolPageNum">
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
    <Icongroup></Icongroup>

	</el-main>
</template>

<script>
	import ContentNav from '../../components/ContentNav'
	import Menu from '../../components/Menu'
	import Icongroup from "../../components/Icon_group";

	export default {
		components: {
			ContentNav,
			Menu,
			Icongroup
		},
		metaInfo() {
			return {
				title: `经典案例-${this.SystemOption.seoTitle ?? ''}`,
				meta: [{ // set meta
					name: 'keywords',
					content: this.SystemOption.seoKeyWord
				}, { // set meta
					name: 'description',
					content: this.SystemOption.seoDescribe
				}]
			}
		},
		created() {
			this.loadSeo();
		},
		data() {
			return {
				MenuList: [{
					id: 0,
					name: "全部"
				}],
				CaseList: [], //案件列表
				Casedetail: '',
				CurrentType: 0, //当前选择类别
				CurrentPage: 1,
				OrderIcons: [{
						val: true,
						ClassName: 'el-icon-bottom'
					},
					{
						val: false,
						ClassName: 'el-icon-top'
					},
				],
				OrderIconVal: 0, //选中的图标值
				SystemOption: [], //SEO 配置
				DesceOrder:true

			}
		},
		computed: {
			//监听菜单栏变化
			getStoreMenuListChecked() {
				return this.$store.state.MenuListChecked;
			},
			getOrder(){
				return  this.$store.state.caseOrder;
			}
		},
		methods: {
			getList() {
				let that = this;
			
				this.axios({
					type: "get",
					url: this.Url.apiUrl + "Case/Case",
					params: {
						CurrentPage: this.CurrentPage,
						num: 10,
						type: this.CurrentType,
						KeyWord: this.ArtickeyWord,
						isDesc: that.DesceOrder
					}
				}).then((res) => {					
					this.CaseList = res.data;
				});
			},
			//模糊搜索
			GetkeyWordArtice() {
				this.getList();
			},
			//查看详情
			getDeatail(item) {
				let that = this;
				this.id = item.id;
				this.$store.state.caseOrder = that.DesceOrder; //设置全局变量排序
				this.$router.push({
					name: 'Casedetail',
					path: '/:caseType/:id.html',
					params: {
						caseType: this.CurrentType,
						id: this.id
					}
				});
			},
			loadSeo() {
				//获取SEO配置
				this.axios.get(this.Url.apiUrl + "SystemOption/GetSystemOption").then(res => this.SystemOption = res.data);
			},
			//分页跳转
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`)
				this.CurrentPage = val ?? 1;
				this.getList();
			},
			//时序降序排列文章
			OrderArticles(index, val) {
				
				console.log(index, val);
				this.OrderIconVal = index;
				this.DesceOrder = val;
				this.$store.state.caseOrder = this.DesceOrder; //设置全局变量排序
				this.getList();
			},
			//路由配置
			loadCaseType(num, v) {
				console.log(num, v);
				this.CurrentType = num;
				this.getList();
			}
		},
		watch: {

			getOrder(e){
				
				this.$store.state.caseOrder = e;
			},
			//按类别查找文章
			getStoreMenuListChecked(e) {
				this.CurrentType = e;
				if (e == 0) {
					//获取全部经典案例文章
					this.axios({
						type: "get",
						url: this.Url.apiUrl + "Case/Case?CurrentPage=1&num=10",
					}).then((res) => {
						this.CaseList = res.data;
					});
				} else {
					this.axios({
						type: "get",
						url: this.Url.apiUrl + "Case/Case?CurrentPage=1&num=10&type=" + e + "",
					}).then((res) => {
						this.CaseList = res.data;
					});
				}
			}
		},
		mounted() {
			//初始化路径数据
			this.$store.state.Currentposition = [{
				path: '/',
				name: '首页'
			}, {
				path: '/case.html',
				name: '经典案例'
			}]
			//获取专业领域
			this.axios({
				type: "get",
				url: this.Url.apiUrl + "ProfessionalField/GetProfessionalField",
			}).then((res) => {
				let data = new Array();
				data.push({
					id: 0,
					name: "全部",
					value: '',
					route: {
						path: "/case.html"
					}
				});
				let len = res.data.length;
				for (let i = 0; i < len; i++) {
					data.push({
						id: res.data[i].id,
						name: res.data[i].name,
						value: res.data[i].pinYinName,
						route: {
							name: 'case',
							params: {
								'caseType': res.data[i].pinYinName
							}
						}
					});
				}
				this.MenuList = data;
			});
			//获取全部经典案例文章
			this.getList();
		}

	}
</script>

<style lang="scss" scoped>
	.content {
		position: relative;
		width: 100%;

		.container {
			position: relative;
			width: 1200px;
			display: flex;
			margin: 0 auto;
			padding: 40px 0;
			justify-content: space-between;

			@media screen and (max-width: 768px) {
				width: 100%;
				display: block;
				padding: 26px 21px;
				overflow: hidden;
			}

			.menu {
				@media screen and (max-width: 768px) {
					display: none;
				}
			}

			.contaniner-content {
				position: relative;
				flex: 0 0 950px;

				.select {
					width: 100%;
					display: flex;
					justify-content: space-between;
					align-items: center;

					.TimeOrder {
						flex: 0 0 150px;
						display: flex;
						color: #202020;
						align-items: center;

						@media screen and (max-width: 768px) {
							display: none;
						}

						i {
							flex: 0 0 8px;
							height: 17px;
							margin: 0 10px;
							font-size: 18px;
							cursor: pointer;
						}
					}

					.InputBox {
						@media screen and (max-width: 768px) {
							width: 100%;

							input {
								width: 100%;
							}
						}
					}
				}

				.itemList {
					position: relative;
					display: block;
					width: 100%;
					margin: 20px 0 0 0;

					.itemList-box {
						border-bottom: 1px solid #d8d8d8;
						height: auto;
						padding: 5px 0;
						margin: 5px 0;

						.title {
							color: #202020;
							font-weight: 600;
							line-height: 36px;
							cursor: pointer;
						}

						.text {
							font-size: 14px;
							color: #908c86;
							line-height: 23px;
						}
					}
				}

				.Pages {
					width: 100%;
					height: 100px;
					display: flex;
					justify-content: center;
					align-items: center;
				}
			}

			.case-details {
				position: relative;
				flex: 0 0 950px;

				.title {
					font-size: 16px;
					font-weight: 600;
					color: #4b4b4b;
				}

				.infor {
					font-size: 12px;
					color: #787878;
					display: flex;

					@media screen and (max-width: 768px) {
						justify-content: space-around;
						align-items: center;
					}

					>div {
						margin-right: 66px;

						@media screen and (max-width: 768px) {
							margin-right: 0;
						}

						i {
							margin-right: 15px;

							@media screen and (max-width: 768px) {
								margin-right: 5px;
							}
						}
					}
				}

				.text {
					font-size: 12px;
					color: #787878;
					margin-top: 18px;
					line-height: 20px;
					max-width: 100%;

					img {
						margin: 20px auto;

						@media screen and (max-width: 768px) {
							width: 100%;
						}
					}
				}

				.last_next {
					position: relative;
					display: flex;
					height: 80px;

					.item {
						flex: 0 0 50%;
						background-color: rgba(240, 240, 240, 0.44);
						display: flex;
						align-items: center;
						justify-content: center;
						color: #797979;
						cursor: pointer;
						user-select: none;
						transition: 200ms;

						i {
							font-size: 20px;
							margin: 0 15px;
						}
					}

					.item:first-of-type {
						border-right: 1px solid rgba(240, 240, 240, 1);
					}

					.item:active {
						background-color: #d0a971;
						color: #fff;
					}
				}
			}
		}
	}
</style>
